<script>
import Datepicker from 'vue3-datepicker';
import moment from 'moment-timezone';

export default {
    components: {
        Datepicker,
    },
    props: {
        modelValue: String, // "YYYYMMDD"
        name: String,
        error: String,
        showErrorBorderOnly: { type: Boolean, default: false },
        disabled: Boolean,
        isNotBgWhite: Boolean,
        minDate: Date,
        maxDate: Date,
        startingView: { type: String, default: 'day' },
        minimumView: { type: String, default: 'day' },
        format: { type: String, default: 'YYYYMMDD' },
        displayFormat: { type: String, default: 'MM/dd/yyyy' },
        placeholder: String,
        addedClass: String,
        textLeft: Boolean,
        wfull: { type: Boolean, default: true },
        dayPickerHeadingFormat: String,
        typeable: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        hasBorder: { type: Boolean, default: true },
        wrapperClass : { type: String },
        menuPlacement: {
            type: String,
            default: 'bottom', // 'top-40' | 'bottom' // 추후 원하는 옵션 추가 후 style에 추가
            validator: (v) => ['top-40', 'bottom'].includes(v),
        },
    },
    mounted() {},
    emits: ['update:modelValue', 'changeDate'],
    methods: {
        getDateMap(dateObject) {
            const year = dateObject.getFullYear();
            const month = String(dateObject.getMonth()).padStart(2, '0');
            const day = String(dateObject.getDate()).padStart(2, '0');
            return { year, month, day };
        },
    },
    computed: {
        dateValue: {
            get() {
                const self = this;
                if (!self.modelValue) return null;
                let date = moment(self.modelValue, self.format);

                self.$emit('update:modelValue', date.format(self.format));
                return date.toDate();
            },
            set(newDate) {
                const self = this;

                const date = self.getDateMap(newDate);
                const parsedDate = moment().year(date.year).month(date.month).date(date.day);

                self.$emit('update:modelValue', parsedDate.format(self.format));
                self.$emit('changeDate', self.modelValue);
            },
        },
        placementClass() {
            // return  `datepicker--left`;
            return  `datepicker--${this.menuPlacement}`;
        },
    }
}

</script>

<template>
    <div :class="[wrapperClass, placementClass]">
        <h1 v-if="name" class="mb-3 text-sm font-semibold text-slate-800">{{ name }}</h1>
        <Datepicker
            :inputFormat="displayFormat"
            class="block w-full border border-border-basic-2 rounded-2 font-body-sm-regular h-[2.75rem]"
            :class="[
                hasBorder ? 'border border-gray-300 rounded-2' : 'border-0 rounded-2',
                wfull ? 'w-full' : '',
                // textLeft ? 'text-left' : 'text-right',
                { 'bg-background-basic-3': disabled, addedClass: addedClass },
                showErrorBorderOnly ? 'border-accent-red-3' : '',
            ]"
            v-model="dateValue"
            :disabled="disabled"
            :lowerLimit="minDate"
            :upperLimit="maxDate"
            :placeholder="placeholder"
            :startingView="startingView"
            :minimumView="minimumView"
            :weekStartsOn="0"
            :dayPickerHeadingFormat="dayPickerHeadingFormat"
            :typeable="typeable"
            :required="required" />
        <p class="mt-1 font-caption-md-regular text-accent-red-3" v-show="error">*{{ error }}</p>
    </div>
</template>

<style lang="scss" scoped>
.drop-up-4rem ::v-deep(.v3dp__popout) {
    top: -4rem;
    z-index: 100;
}

.datepicker--bottom :deep(.v3dp__popout) {
    top: calc(100% + 4px);
    bottom: auto;
    left: 0;
}

.datepicker--top-40 :deep(.v3dp__popout) {
    bottom: calc(40%);
    // top: auto;
}

</style>
